export default {
  login: {
    login: 'Login',
    loginSubtitle: 'Sign in to your FFS account',
    username: 'Account',
    password: 'Password',
    forgetPassword: 'Forget Password?'
  },
  forgetPassword: {
    forgetPassword: 'Reset Password',
    forgetPasswordSubtitle: 'Enter the following information to reset your password',
    username: 'Username',
    backToLogin: 'Back To Login',
    success: 'Your password has been reset. It will be return to the login page in 5 second',
    oneTimePassword: 'Enter your one time password.',
    newPassword: 'Enter your new password.',
    confirmNewPassword: 'Confirm your new password',
    example: 'Example: 12345678 (Mobile phone number)',
    advise: 'Your password should be at least 8 characters in length and mixed with uppercase/lowercase letter and digit.',
    notice: 'Your one-time password has been send, please check your message at the following time.',
    sendOneTimePassword: 'Send one Time Password',
    countryCallingCode: 'Country calling code',
    fail: 'Either username or one time password is wrong. Please make sure you enter the correct information.',
    sendOneTimePasswordAgain: 'One time password will send after: ',
    cooldown: 'One time password is cooling down, please try again later.'
  }
}



// WEBPACK FOOTER //
// ./src/Auth/langs/en_us/index.js